export const styles = () => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
    },
    image: {
        maxWidth: '100%'
    }
    
})
